// ===============================================================
// ✅ CallHistoryItem.js — LIVORA Call Row
// ===============================================================

import React from "react";
import {
  FaVideo,
  FaPhoneSlash,
  FaArrowUp,
  FaArrowDown,
} from "react-icons/fa";
import { defaultAvatarByGender } from "../../utils/defaultAvatar";
import {
  getCallOtherParty,
  getCallDirection,
  getCallVisualState,
  formatClock,
  formatDateLabel,
  formatDuration,
  toMillisSafe,
} from "./callHelpers";

export default function CallHistoryItem({ call, myUid, onRecall, t }) {
  const other = getCallOtherParty(call, myUid, t);
  const direction = getCallDirection(call, myUid);
  const visual = getCallVisualState(call, myUid, t);

  const fallbackAvatar = defaultAvatarByGender(other?.gender);
  const avatarSrc = call?.otherUserPhoto || fallbackAvatar;

  const timeMs =
    toMillisSafe(call?.createdAt) ||
    toMillisSafe(call?.startedAt) ||
    toMillisSafe(call?.endedAt);

  const duration = formatDuration(call?.durationSeconds);
  const clock = formatClock(timeMs);
  const date = formatDateLabel(timeMs);

  return (
    <div className={`la-call-card ${visual.className}`}>
      <div className="la-call-left">
        <div className="la-call-avatar-wrap">
          <img
            src={avatarSrc}
            alt={t("calls.avatar_alt", { defaultValue: "Avatar" })}
            className="la-call-avatar"
            onError={(e) => {
              if (e.currentTarget.src !== fallbackAvatar) {
                e.currentTarget.onerror = null;
                e.currentTarget.src = fallbackAvatar;
              }
            }}
          />

          {visual.missed && <span className="la-call-unread-dot" />}
        </div>

        <div className="la-call-main">
          <div className="la-call-top">
            <span className="la-call-name">
              {other.name || t("chat.user", { defaultValue: "مستخدم" })}
            </span>
            <span className="la-call-time">{clock}</span>
          </div>

          <div className="la-call-bottom">
            <span className={`la-call-status ${visual.className}`}>
              <span className="la-call-dir-icon">
                {direction === "outgoing" ? <FaArrowUp /> : <FaArrowDown />}
              </span>

              <span>{visual.label}</span>

              {duration ? (
                <span className="la-call-meta-piece">• {duration}</span>
              ) : null}

              {date ? (
                <span className="la-call-meta-piece">• {date}</span>
              ) : null}
            </span>
          </div>
        </div>
      </div>

      <button
        type="button"
        className={`la-call-action-btn ${visual.missed ? "missed" : ""}`}
        onClick={() => onRecall(call)}
        title={t("calls.call_again", { defaultValue: "اتصال مرة أخرى" })}
      >
        {visual.missed ? <FaPhoneSlash /> : <FaVideo />}
      </button>
    </div>
  );
}